/**
 * @generated SignedSource<<0005d47f86b21ced33a11a25eac6ed16>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateCriterionInput = {
  clientMutationId?: string | null | undefined;
  patch: CriterionPatch;
  rowId: any;
};
export type CriterionPatch = {
  ageRange?: IntRangeInput | null | undefined;
  isLocationDealbreaker?: boolean | null | undefined;
  isRecentlyActive?: boolean | null | undefined;
  isVerified?: boolean | null | undefined;
  maxDistance?: number | null | undefined;
  maxDistanceInKm?: number | null | undefined;
  maxDistanceInMi?: number | null | undefined;
};
export type IntRangeInput = {
  end?: IntRangeBoundInput | null | undefined;
  start?: IntRangeBoundInput | null | undefined;
};
export type IntRangeBoundInput = {
  inclusive: boolean;
  value: number;
};
export type useCriteriaMutation$variables = {
  input: UpdateCriterionInput;
};
export type useCriteriaMutation$data = {
  readonly updateCriterion: {
    readonly query: {
      readonly " $fragmentSpreads": FragmentRefs<"useCriteria_query">;
    } | null | undefined;
  } | null | undefined;
};
export type useCriteriaMutation = {
  response: useCriteriaMutation$data;
  variables: useCriteriaMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCriteriaMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateCriterionPayload",
        "kind": "LinkedField",
        "name": "updateCriterion",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "useCriteria_query"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useCriteriaMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateCriterionPayload",
        "kind": "LinkedField",
        "name": "updateCriterion",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Criterion",
                    "kind": "LinkedField",
                    "name": "criterion",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "IntRange",
                        "kind": "LinkedField",
                        "name": "ageRange",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "IntRangeBound",
                            "kind": "LinkedField",
                            "name": "start",
                            "plural": false,
                            "selections": (v2/*:: as any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "IntRangeBound",
                            "kind": "LinkedField",
                            "name": "end",
                            "plural": false,
                            "selections": (v2/*:: as any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isRecentlyActive",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isLocationDealbreaker",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isVerified",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "maxDistanceInKm",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "maxDistanceInMi",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rowId",
                        "storageKey": null
                      },
                      (v3/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v3/*:: as any*/)
                ],
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "16c6436ce6ddb45b23b7ce8b9e53533b",
    "id": null,
    "metadata": {},
    "name": "useCriteriaMutation",
    "operationKind": "mutation",
    "text": "mutation useCriteriaMutation(\n  $input: UpdateCriterionInput!\n) {\n  updateCriterion(input: $input) {\n    query {\n      ...useCriteria_query\n      id\n    }\n  }\n}\n\nfragment useCriteria_query on Query {\n  currentUser {\n    criterion {\n      ageRange {\n        start {\n          value\n        }\n        end {\n          value\n        }\n      }\n      isRecentlyActive\n      isLocationDealbreaker\n      isVerified\n      maxDistanceInKm\n      maxDistanceInMi\n      rowId\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "52350d56723560db8703a3ca4d91d43d";

export default node;
